module.exports = "<div class=\"container\"><p>  Angular Fullstack v4.1.2 | <a href=\"http://angular-fullstack.github.io/generator-angular-fullstack\">Documentation</a> | <a href=\"https://gitter.im/DaftMonk/generator-angular-fullstack\">Chat on Gitter</a> | <a href=\"https://github.com/angular-fullstack/generator-angular-fullstack/issues?state=open\">Issues</a> | <a href=\"https://opencollective.com/angular-fullstack\">Donate to our Open Collective</a></p></div>";


//////////////////
// WEBPACK FOOTER
// ./client/components/footer/footer.pug
// module id = 270
// module chunks = 0